import { Star } from 'lucide-react';

export const GoldStars = () => (
  <div className="flex items-center gap-0.5">
    <Star size={20} className="fill-[#FFD700] text-[#FFD700]" />
    <Star size={20} className="fill-[#FFD700] text-[#FFD700]" />
    <Star size={20} className="fill-[#FFD700] text-[#FFD700]" />
    <Star size={20} className="fill-[#FFD700] text-[#FFD700]" />
    <Star size={20} className="fill-[#FFD700] text-[#FFD700]" />
  </div>
);
